import defaultState from './default';
import disabled from './disabled';

export default {
  default: defaultState,
  disabled,
};
